import type { ReactNode } from "react";
import type { UseFormRegister } from "react-hook-form";
import { Field } from "./Field";
import { RegistrationValues } from "../types/registration";
import { countryOptions } from "../constants/register";
import { codeSelectClass, inputClass } from "../styles";

export function CountryPhoneField({
  label,
  error,
  icon,
  codeName,
  phoneName,
  register,
  placeholder,
  getCountryLabel,
}: {
  label: string;
  error?: string;
  icon: ReactNode;
  codeName: keyof RegistrationValues;
  phoneName: keyof RegistrationValues;
  register: UseFormRegister<RegistrationValues>;
  placeholder: string;
  getCountryLabel: (option: (typeof countryOptions)[number]) => string;
}) {
  return (
    <Field label={label} error={error} icon={icon}>
      <div className="flex gap-2">
        <select className={`${codeSelectClass} w-44`} {...register(codeName)}>
          {countryOptions.map((option) => (
            <option key={option.code} value={option.code}>
              {getCountryLabel(option)}
            </option>
          ))}
        </select>
        <input className={`${inputClass} flex-1`} placeholder={placeholder} {...register(phoneName)} />
      </div>
    </Field>
  );
}